module.exports = __webpack_public_path__ + "static/media/FL_BNobleM_en15.7806986c.png";